<template>
  <div class="contact-container">
    <button class="contact-add-link-button" @click="onContactClick()" v-if="buttonText">
      {{buttonText}}
    </button>
    <button class="contact-button-icon" @click="onContactClick()" v-else>
      <font-awesome-icon :icon="['fa', 'envelope']" size="1x">
      </font-awesome-icon>
    </button>
    <div class="backdrop" v-if="showPopup">
      <div class="popup" v-on-clickaway="hidePopup">
        <font-awesome-icon :icon="['fas', 'times']" size="1x" class="x-button"
          @click="hidePopup()">
        </font-awesome-icon>
        <h2>Send a Message to {{receiverDisplayName}}</h2>
        <div class="edit-form">
          <label>Name</label>
          <input type="text" v-model="senderDisplayName" maxlength="50"/>
          <span class="remaining-characters">{{50 - senderDisplayName.length}}/50</span>
        </div>
        <div class="edit-form">
          <label>Email</label>
          <input type="email" v-model="senderEmail" maxlength="200"/>
        </div>
        <div class="edit-form">
          <label>Message</label>
          <textarea type="text" v-model="message" maxlength="500" rows="4"/>
          <span class="remaining-characters">{{500 - message.length}}/500</span>
        </div>
        <div class="buttons">
          <button class="cancel" aria-label="Cancel"
          @click="showPopup = false">Cancel</button>
          <button class="submit" aria-label="Submit"
          @click="submit">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ContactUser',
  mixins: [clickaway],
  props: {
    receiverUserName: {
      type: String,
      default: '',
    },
    receiverDisplayName: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      defaut: '',
    },
  },
  data() {
    return {
      showPopup: false,
      senderDisplayName: '',
      senderEmail: '',
      message: '',
    };
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
  },
  methods: {
    ...mapActions('auth', ['authenticate']),
    async onContactClick() {
      if (await this.authenticate()) {
        this.showPopup = true;
      }
    },
    hidePopup() {
      this.showPopup = false;
    },
    async submit() {
      const {
        senderDisplayName, senderEmail, message, receiverUserName,
      } = this;
      this.$ga.event('event', 'click', 'contactUserSubmit', 1);
      try {
        await this.backendAxios.post('/user/message/', {
          senderDisplayName,
          senderEmail,
          message,
          receiverUserName,
        });
        this.showPopup = false;
        this.senderDisplayName = '';
        this.senderEmail = '';
        this.message = '';
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.contact-container {
  position: relative;
}

.contact-button-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
  background: white;
  border-radius: 50%;
  font-size: 1rem;
  height: 2rem;
  width: 2rem;
  color: white;
  text-decoration: none;
  cursor: pointer;
  & > svg {
    color: black;
  }
}

.backdrop {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  transition: all 0.3s;
  z-index: 100;
}

.popup {
  position: absolute;
  text-align: center;
  max-width: 25rem;
  padding: 2rem;
  width: 80%;
  max-height: 75%;
  overflow: scroll;
  background-color: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  border-radius: 0.375rem;
  -webkit-font-smoothing: antialiased;
}

.contact-popup {
  position: absolute;
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
}

.buttons > button {
  padding: 0.5rem 0.75rem;
  border-radius: 0.2rem;
  font-size: 1rem;
  border:none;
  font-weight: 700;
  white-space: nowrap;
  letter-spacing: .025rem;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
  cursor: pointer;
}

.submit {
  color: #fff;
  background-color: $login-background;
}


.cancel {
  margin-right: 2rem;
  background-color: #fff;
  color: $login-background;
}

.x-button {
  position: absolute;
  top: 0.625rem;
  right: 0.25rem;
  margin: 1rem;
  cursor: pointer;
  &:hover {
    filter: brightness(0.6);
  }
}
.contact-add-link-button {
    line-height: 0.8;
    justify-content: center;
    border-width: 1px;
    border-style: solid;
    border-radius: 3px;
    background-color: #fff;
    color: #444444;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    padding: 11px 24px;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,.05);
}

</style>
